/**
 * @author: Corey Sanford <corey@hackcapital.com>
 * @date:   2019-01-04 10:14:38
 *
 * Constructor of keyword search
 */

import { QueryBuilderBase } from './QueryBuilderBase';

export class SearchQueryBuilder extends QueryBuilderBase {
}
